import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Target, Eye, Heart, Award, Users, Handshake, TrendingUp, Shield } from 'lucide-react';
export const AboutPage = () => {
  const coreValues = [{
    icon: <Users size={32} className="text-primary-600" data-id="element-1272" />,
    title: 'Customer First',
    description: 'We prioritize our customers needs and satisfaction in everything we do, building lasting relationships based on trust and mutual success.'
  }, {
    icon: <Shield size={32} className="text-primary-600" data-id="element-1273" />,
    title: 'Integrity',
    description: 'We operate with transparency, honesty, and ethical practices, ensuring fair treatment and clear communication with all stakeholders.'
  }, {
    icon: <TrendingUp size={32} className="text-primary-600" data-id="element-1274" />,
    title: 'Excellence',
    description: 'We strive for excellence in service delivery, continuously improving our processes and products to exceed expectations.'
  }, {
    icon: <Heart size={32} className="text-primary-600" data-id="element-1275" />,
    title: 'Empowerment',
    description: 'We empower Kenyan entrepreneurs with the financial tools and support they need to achieve their business dreams and create lasting impact.'
  }];
  return <div className="min-h-screen bg-white" data-id="element-1276">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary-600 to-primary-700 text-white py-20" data-id="element-1277">
        <div className="container" data-id="element-1278">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1279">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-1280">
              About Geldhaus
            </h1>
            <p className="text-xl md:text-2xl text-primary-100 leading-relaxed" data-id="element-1281">
              "The Business Partner taking you to the next Level."
            </p>
          </div>
        </div>
      </section>

      {/* Who We Are */}
      <section id="who-we-are" className="py-20 bg-white" data-id="element-1282">
        <div className="container" data-id="element-1283">
          <div className="max-w-4xl mx-auto" data-id="element-1284">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-1285">
              Who We Are
            </h2>
            <div className="prose prose-lg max-w-none text-gray-600 space-y-4" data-id="element-1286">
              <p data-id="element-1287">
                Geldhaus Africa is a leading financial services provider in
                Kenya. Since our establishment in 2025, we have been at the
                forefront of providing accessible, flexible, and innovative
                financing solutions to Kenyan entrepreneurs and businesses.
              </p>
              <p data-id="element-1288">
                With every passing day, we are supporting businesses across
                Kenya to grow, scale, and thrive. We specialize in empowering
                small and medium-sized enterprises (SMEs) with the capital they
                need to succeed in Kenya's dynamic business environment. Our
                comprehensive range of products includes logbook loans, business
                loans, asset financing, trade finance solutions, and
                buy-now-pay-later options for productive assets.
              </p>
              <p data-id="element-1289">
                We have established ourselves as a trusted financial partner for
                Kenyan entrepreneurs. Our commitment to fast approval times
                (1-12 hours), transparent pricing, and personalized support sets
                us apart in the industry. With a 90% approval rate, we're proud
                to be the partner that businesses trust when they need financing
                to reach the next level.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision, Purpose */}
      <section className="py-20 bg-gray-50" data-id="element-1290">
        <div className="container" data-id="element-1291">
          <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-1292">
            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-primary-100" data-id="element-1293">
              <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-1294">
                <Target size={32} className="text-primary-600" data-id="element-1295" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900" data-id="element-1296">
                Our Mission
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1297">
                To empower Kenyan entrepreneurs with accessible, flexible, and
                innovative financing solutions that drive business growth,
                create jobs, and contribute to economic development.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-primary-100" data-id="element-1298">
              <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-1299">
                <Eye size={32} className="text-primary-600" data-id="element-1300" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900" data-id="element-1301">
                Our Vision
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1302">
                To be East Africa's most trusted and innovative financial
                partner for SMEs, recognized for our customer-centric approach,
                technological excellence, and positive impact on
                entrepreneurship.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border-2 border-primary-100" data-id="element-1303">
              <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mb-6" data-id="element-1304">
                <Heart size={32} className="text-primary-600" data-id="element-1305" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-900" data-id="element-1306">
                Our Purpose
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-1307">
                To unlock the potential of Kenyan businesses by providing the
                financial resources and support they need to transform their
                dreams into thriving enterprises that create lasting value.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Motto */}
      <section className="py-16 bg-gradient-to-r from-primary-600 to-primary-700 text-white" data-id="element-1308">
        <div className="container" data-id="element-1309">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1310">
            <Award size={48} className="mx-auto mb-6" data-id="element-1311" />
            <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-1312">Our Motto</h3>
            <p className="text-3xl md:text-4xl font-bold italic" data-id="element-1313">
              "Empowering Growth, Building Futures"
            </p>
          </div>
        </div>
      </section>

      {/* Core Values */}
      <section className="py-20 bg-white" data-id="element-1314">
        <div className="container" data-id="element-1315">
          <div className="text-center mb-16" data-id="element-1316">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-1317">
              Our Core Values
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-1318">
              These principles guide our decisions, shape our culture, and
              define how we serve our customers every day.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1319">
            {coreValues.map((value, index) => <div key={index} className="bg-white p-8 rounded-2xl border-2 border-gray-200 hover:border-primary-300 hover:shadow-xl transition-all duration-300" data-id="element-1320">
                <div className="w-16 h-16 bg-primary-50 rounded-2xl flex items-center justify-center mb-6" data-id="element-1321">
                  {value.icon}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-gray-900" data-id="element-1322">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-1323">
                  {value.description}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Why Choose Geldhaus */}
      <section className="py-20 bg-gray-50" data-id="element-1324">
        <div className="container" data-id="element-1325">
          <div className="max-w-4xl mx-auto" data-id="element-1326">
            <h2 className="text-3xl md:text-4xl font-bold mb-12 text-gray-900 text-center" data-id="element-1327">
              Why Choose Geldhaus
            </h2>

            <div className="space-y-6" data-id="element-1328">
              <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-primary-600" data-id="element-1329">
                <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-1330">
                  Trusted Financial Partner
                </h3>
                <p className="text-gray-600" data-id="element-1331">
                  We are committed to providing reliable and transparent
                  financial services, ensuring your financial security and peace
                  of mind.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-primary-600" data-id="element-1332">
                <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-1333">
                  Fast Approval Process
                </h3>
                <p className="text-gray-600" data-id="element-1334">
                  Our streamlined digital application process delivers decisions
                  in 1-12 hours, getting you the funds you need when you need
                  them.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-primary-600" data-id="element-1335">
                <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-1336">
                  Flexible Solutions
                </h3>
                <p className="text-gray-600" data-id="element-1337">
                  We offer customized financing solutions tailored to your
                  business needs, with flexible repayment terms that align with
                  your cash flow.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-primary-600" data-id="element-1338">
                <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-1339">
                  Expert Support
                </h3>
                <p className="text-gray-600" data-id="element-1340">
                  Our dedicated relationship managers understand your industry
                  and provide personalized guidance throughout your financing
                  journey.
                </p>
              </div>

              <div className="bg-white rounded-xl p-6 shadow-md border-l-4 border-primary-600" data-id="element-1341">
                <h3 className="text-xl font-bold mb-2 text-gray-900" data-id="element-1342">
                  Proven Track Record
                </h3>
                <p className="text-gray-600" data-id="element-1343">
                  With a 90% approval rate and thousands of satisfied clients,
                  we have a proven track record of empowering Kenyan businesses
                  to succeed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Partnerships */}
      <section className="py-20 bg-white" data-id="element-1344">
        <div className="container" data-id="element-1345">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1346">
            <div className="w-20 h-20 bg-primary-100 rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-1347">
              <Handshake size={40} className="text-primary-600" data-id="element-1348" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900" data-id="element-1349">
              Partnerships
            </h2>
            <div className="bg-gradient-to-br from-primary-50 to-white rounded-2xl p-12 border-2 border-primary-200" data-id="element-1350">
              <p className="text-2xl font-semibold text-primary-700 mb-4" data-id="element-1351">
                Coming Soon
              </p>
              <p className="text-gray-600 text-lg" data-id="element-1352">
                We are actively building strategic partnerships with leading
                financial institutions, technology providers, and industry
                associations to enhance our service offerings and expand our
                reach across East Africa.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-primary-600 to-primary-700 text-white" data-id="element-1353">
        <div className="container" data-id="element-1354">
          <div className="max-w-4xl mx-auto text-center" data-id="element-1355">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-1356">
              Ready to Take Your Business to the Next Level?
            </h2>
            <p className="text-xl text-primary-100 mb-8" data-id="element-1357">
              Join thousands of successful Kenyan entrepreneurs who trust
              Geldhaus as their financial partner.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1358">
              <a href="/apply" className="bg-white text-primary-600 hover:bg-primary-50 font-bold py-4 px-8 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-1359">
                Apply for Financing
              </a>
              <a href="/#contact" className="bg-white/10 backdrop-blur-sm text-white hover:bg-white/20 font-bold py-4 px-8 rounded-xl border-2 border-white transition-all duration-300" data-id="element-1360">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-1361" />
    </div>;
};